import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'
import { toMultiListFiles } from '../DocFlow.utils.files'
import { DocFlowSendingFieldName } from '../DocFlowSending'

import { ROW_ACTIONS_CONFIG } from './DocFlowSendingTableRow.constants'
import { renderDocFlowSendingTableCell } from './DocFlowSendingTableRow.utils'

import * as styles from './DocFlowSendingTableRow.module.css'

function DocFlowSendingTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isLoading,
  isResizing,
  isSelected,
  isShort,
  item,
  permissions,
  phaseDisabled,
  resizingColumn,
  showCellBorder,
  onToggleSaveToProfile,
  onToggleSendAdditionalEmail,
  onToggleSendEmail,
  onToggleSendEpost,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    handleCallAction,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, ROW_ACTIONS_CONFIG)

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files: item[DocFlowSendingFieldName.File],
    })

  const preparedFiles = toMultiListFiles(item[DocFlowSendingFieldName.File], t)

  const className = useTableRowModClassName({
    className: styles.DocFlowSendingTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  function handleToggleSendEmail(value) {
    onToggleSendEmail({ item, value })
  }

  function handleToggleToProfile(value) {
    onToggleSaveToProfile({ item, value })
  }

  function handleToggleSendEpost(value) {
    onToggleSendEpost({ item, value })
  }

  function handleToggleSendAdditionalEmail(value) {
    onToggleSendAdditionalEmail({ item, value })
  }

  return (
    <>
      <div
        {...qaProps}
        className={className}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {Actions ? (
          <Actions
            disabled={phaseDisabled || hideCheckbox || item.uploading}
            selected={isSelected}
            width={actionsColumnWidth}
            onChange={handleSelect}
          />
        ) : null}
        {columns.map(column => (
          <Fragment key={column.name}>
            {renderDocFlowSendingTableCell({
              isActive: column.name === resizingColumn,
              isLoading,
              isResizing,
              isShort,
              item,
              name: column.name,
              permissions,
              phaseDisabled,
              preparedFiles,
              showCellBorder,
              t,
              width: column.width,
              onClickFile: handleClickFile,
              onToggleSaveToProfile: handleToggleToProfile,
              onToggleSendAdditionalEmail: handleToggleSendAdditionalEmail,
              onToggleSendEmail: handleToggleSendEmail,
              onToggleSendEpost: handleToggleSendEpost,
            })}
          </Fragment>
        ))}
        <TableCellFreeSpaceFiller width={emptyColumnSize} />
        {getActions?.(item).length > 0 && !phaseDisabled ? (
          <TableRowContextActions
            actionLeft={actionLeft}
            focusedRow={focusedRow}
            getActions={getActions}
            item={item}
            onCallAction={handleCallAction}
          />
        ) : null}
      </div>
      <FilesPreviewGallery
        files={item[DocFlowSendingFieldName.File]}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default DocFlowSendingTableRow
